import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Briefcase, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const HiringBanner = () => {
  return (
    <section className="py-12 bg-slate-900">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="bg-gradient-to-r from-orange-600/20 via-pink-600/20 to-purple-600/20 backdrop-blur-md border border-white/20 rounded-2xl p-6 md:p-8">
            {/* Desktop Layout */}
            <div className="hidden md:flex items-center justify-between gap-6">
              <div className="flex items-start gap-4 flex-1">
                <div className="p-3 bg-orange-500/20 rounded-xl">
                  <Briefcase className="h-8 w-8 text-orange-400" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-2">Looking to Hire Certified Video Editors?</h3>
                  <p className="text-gray-300 text-lg">
                    <span className="text-orange-400 font-semibold">125+ Hiring Partners</span> • <span className="text-purple-400 font-semibold">500+ Students Placed</span>
                  </p>
                  <p className="text-gray-400 text-sm mt-2">Industry-ready professionals trained by award-winning editors</p>
                </div>
              </div>
              <div className="flex flex-col gap-3 shrink-0">
                <Link to="/hiring-partners" data-testid="hiring-banner-cta-desktop">
                  <Button
                    className="bg-gradient-to-r from-orange-600 to-pink-600 hover:from-orange-700 hover:to-pink-700 text-white px-8 py-6 text-lg rounded-xl shadow-lg transform hover:scale-105 transition-all whitespace-nowrap w-full"
                  >
                    Hire from MatchFrame
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Button>
                </Link>
                <Button
                  onClick={() => (window.location.href = 'tel:+919632406669')}
                  variant="outline"
                  className="bg-white/5 border border-white/20 hover:bg-white/10 text-white px-8 py-5 rounded-xl whitespace-nowrap"
                >
                  <Phone className="mr-2 h-4 w-4" />
                  Call Us Now
                </Button>
              </div>
            </div>

            {/* Mobile Layout */}
            <div className="md:hidden space-y-4">
              <div className="flex items-start gap-3">
                <div className="p-2.5 bg-orange-500/20 rounded-xl flex-shrink-0">
                  <Briefcase className="h-6 w-6 text-orange-400" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-white mb-2 leading-tight">Looking to Hire Certified Video Editors?</h3>
                  <p className="text-gray-300 text-sm mb-1">
                    <span className="text-orange-400 font-semibold">125+ Hiring Partners</span>
                  </p>
                  <p className="text-gray-300 text-sm mb-2">
                    <span className="text-purple-400 font-semibold">500+ Students Placed</span>
                  </p>
                  <p className="text-gray-400 text-xs">Industry-ready professionals trained by award-winning editors</p>
                </div>
              </div>
              <Link to="/hiring-partners" data-testid="hiring-banner-cta-mobile">
                <Button
                  className="w-full bg-gradient-to-r from-orange-600 to-pink-600 hover:from-orange-700 hover:to-pink-700 text-white px-6 py-4 text-base rounded-xl shadow-lg transform active:scale-95 transition-all"
                >
                  Hire from MatchFrame
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
              <Button
                onClick={() => (window.location.href = 'tel:+919632406669')}
                variant="outline"
                className="w-full bg-white/5 border border-white/20 hover:bg-white/10 text-white px-6 py-4 text-base rounded-xl"
              >
                <Phone className="mr-2 h-4 w-4" />
                Call Us Now
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
